import { UserAvatar, Heading, Paragraph } from '@app/shared/ui/atoms/Common';
import { Gender } from '@app/shared/types/common';
import { diamondIcon } from '@app/assets';

interface UserInfoSectionProps {
  userName?: string | null;
  avatar?: string | null;
  gender?: Gender | null;
  tonBalance?: number;
  isUserLoading: boolean;
}

export function UserInfoSection({
  userName,
  avatar,
  gender,
  tonBalance,
  isUserLoading,
}: UserInfoSectionProps) {
  return (
    <section className="flex items-center gap-6">
      <UserAvatar
        avatar={avatar}
        isAvatarLoading={isUserLoading}
        gender={gender}
        className="size-32"
      />
      <div className="flex flex-col gap-1">
        <Heading level={3}>{userName}</Heading>
        <Paragraph variant="accent" size="xl" className="flex gap-1">
          {tonBalance} <img src={diamondIcon} alt="diamond" className="w-5" />
        </Paragraph>
      </div>
    </section>
  );
}
